"use client";
import React, { useEffect, useRef } from "react";
import Player from "@vimeo/player";

const VimeoPlayer = ({ videoId }) => {
  const playerRef = useRef(null);

  useEffect(() => {
    const iframe = playerRef.current;
    const player = new Player(iframe);

    player.on("play", () => console.log("Video is playing"));
    player.on("pause", () => console.log("Video is paused"));
    player.on("ended", () => console.log("Video ended"));

    const lastTime = localStorage.getItem(`vimeo-${videoId}`);
    if (lastTime) {
      player.setCurrentTime(parseFloat(lastTime)).catch(() => {});
    }

    const interval = setInterval(() => {
      player.getCurrentTime().then((seconds) => {
        localStorage.setItem(`vimeo-${videoId}`, seconds);
      });
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [videoId]);

  return (
    <div className="relative">
      <iframe
        ref={playerRef}
        src={`https://player.vimeo.com/video/${videoId}?dnt=1&title=0&byline=0&portrait=0&pip=0&badge=0&transparent=0`}
        className="z-0"
        width="100%"
        height="480"
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default VimeoPlayer;
